import TableTemplate from "../../TableTemplate/tableTemplate";
import { IWhiteListTableReport } from "../../../Interfaces/optionDomain";
import { getWhiteListTable } from "../../../Requests/optionDomain";
import { CommonTableUI } from "../../TableTemplate/common";

const WhiteListTable = () => {
  return (
    <TableTemplate<any, IWhiteListTableReport>
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          sortingType={sortingType}
          setSortingType={setSortingType}
        />
      )}
      getDataTable={getWhiteListTable}
      withSort
    />
  );
};

export default WhiteListTable;
